import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.reduce.js";

/* eslint-disable */
// import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
export function handle(promise, errorExt) {
  return promise.then(function (data) {
    return [null, data];
  })["catch"](function (err) {
    if (errorExt) {
      Object.assign(err, errorExt);
    }

    return [err, undefined];
  });
}
export function formatDate(d) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";

  if (d) {
    var month = "" + (d.getMonth() + 1);
    var day = "" + d.getDate();
    var year = d.getFullYear();
    month = month.length < 2 ? "0" + month : month;
    day = day.length < 2 ? "0" + day : day;
    return [month, day, year].join(sep);
  } else {
    return null;
  }
}
export function parseDate(str) {
  if (str) {
    try {
      return moment(str).toDate();
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
}
export function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  minutes = minutes < 10 ? "0" + minutes : minutes;
  hours = hours < 10 ? "0" + hours : hours;
  return hours + ":" + minutes + " " + ampm;
}
export function formatPhoneNumber(phoneNumberString) {
  if (phoneNumberString) {
    var match = phoneNumberString.replace(/\D+/g, "") // .replace(/^1/, "")
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0];
    var part1 = match.length > 2 ? "(".concat(match.substring(0, 3), ")") : match;
    var part2 = match.length > 3 ? " ".concat(match.substring(3, 6)) : "";
    var part3 = match.length > 6 ? "-".concat(match.substring(6, 10)) : "";
    return "".concat(part1).concat(part2).concat(part3);
  } else {
    return phoneNumberString;
  }
}

function getISOTimezoneOffset(date) {
  var offset = date.getTimezoneOffset();
  return (offset < 0 ? "+" : "-") + leftPad(Math.floor(Math.abs(offset / 60)) + "", 2) + ":" + leftPad(Math.abs(offset % 60) + "", 2);
}

function leftPad(s, size) {
  while (s.length < (size || 2)) {
    s = "0" + s;
  }

  return s;
}

function getISOLocaleString(date) {
  return date.getFullYear() + "-" + leftPad(date.getMonth() + 1 + "", 2) + "-" + leftPad(date.getDate() + "", 2) + "T" + leftPad(date.getHours() + "", 2) + ":" + leftPad(date.getMinutes() + "", 2) + ":" + leftPad(date.getSeconds() + "", 2) + "." + leftPad(date.getMilliseconds() + "", 3);
}

function randomNumber() {
  var seed = new Date().getTime();
  seed = seed & 0xffffffff;
  seed = seed + 0x7ed55d16 + (seed << 12) & 0xffffffff;
  seed = (seed ^ 0xc761c23c ^ seed >>> 19) & 0xffffffff;
  seed = seed + 0x165667b1 + (seed << 5) & 0xffffffff;
  seed = (seed + 0xd3a2646c ^ seed << 9) & 0xffffffff;
  seed = seed + 0xfd7046c5 + (seed << 3) & 0xffffffff;
  seed = (seed ^ 0xb55a4f09 ^ seed >>> 16) & 0xffffffff;
  return (seed & 0xfffffff) / 0x10000000;
}

function uuidv4() {
  var seed = randomNumber();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = seed * 16 | 0,
        v = c == "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

export function getGUID() {
  return uuidv4();
}
export function getTimeInUTC() {
  return moment(moment().toDate().toUTCString().split("GMT")[0] + " UTC").toDate().toISOString();
}
export function getLocalISODateString(date) {
  return getISOLocaleString(date) + getISOTimezoneOffset(date);
}
export function parseAndConvertDates(obj) {
  if (obj) {
    for (var property in obj) {
      if (obj.hasOwnProperty(property)) {
        var propVal = obj[property];
        var clss = propVal && propVal["@class"];
        var idx = clss ? clss.indexOf("XMLGregorianCalendarImpl") : -1;

        if (idx > 0) {
          try {
            var dtStr = [[propVal.month, propVal.day, propVal.eonAndYear].join("-"), [propVal.hour, propVal.minute, propVal.second].join(":"), "UTC"].join(" ");
            obj[property] = moment(dtStr).toDate();
          } catch (_e) {
            obj[property] = propVal;
          }
        } else {
          if (typeof obj[property] === "object") {
            parseAndConvertDates(obj[property]);
          }
        }
      }
    }
  }

  return obj;
}
export function hashCode(obj) {
  if (obj) {
    var str = typeof obj === "string" ? obj : this.sortedStringify(obj, null);

    if (str) {
      return str.split("").reduce(function (prevHash, currVal) {
        return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
      }, 0) + "";
    } else {
      return str;
    }
  } else {
    return null;
  }
}